module.exports = __webpack_public_path__ + "static/jersey-44d0927fbf082142b40738ce8c6664f7.jpg";